import type { FC } from "react";

import { Label } from "@/ui/components/form/Label";
import type {
  TFieldsetProps,
} from "@/ui/components/form/Fieldset/Fieldset.config";
import { Stack } from "@/ui/components/layout/Stack";

export const Fieldset: FC<TFieldsetProps> = ({ label, children }) => (
  <fieldset data-component="Fieldset" className="w-full">
    <legend className="mb-4">
      <Label>{ label }</Label>
    </legend>
    <Stack>
      { children }
    </Stack>
  </fieldset>
);

Fieldset.displayName = "Fieldset";
